import React from "react";

const skills = [
    { name: 'Unity', level: 'Advanced' },
    { name: 'C#', level: 'Advanced' },
    { name: 'Microsoft Office', level: 'Advanced' },
    { name: 'React', level: 'Intermediate' },
    { name: 'Tailwind', level: 'Intermediate' },
    { name: 'Lua', level: 'Intermediate' },
    { name: 'Roblox Studio', level: 'Intermediate' },
    { name: 'Blender', level: 'Intermediate' },
    { name: 'Jira', level: 'Intermediate' },
    { name: 'Trello', level: 'Intermediate' },
];

const levelColors = {
    Advanced: 'text-red-300',
    Intermediate: 'text-red-200/70',
};

export default function Skills() {
    return (
        <section id="skills" className="max-w-7xl px-4 py-2">
            <div className="bg-black/90 rounded-xl border border-red-400/30 shadow-lg shadow-black/40 px-6 py-5">
                <h2 className="text-4xl font-bold text-white tracking-tight pl-2">Skills</h2>
                <hr className="mt-2 border-t-2 border-red-400 w-[6.25rem]" />
                <p className="text-gray-400 text-base italic mt-3">These are my best skills, not my only ones.</p>

                <div className="bg-gray-800/20 border border-red-400/20 rounded-lg px-5 py-5 mt-6">
                    <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2 items-start">
                        {skills.map(({ name, level }) => (
                            <li
                                key={name}
                                className="bg-gray-800/80 hover:bg-gray-700 border border-transparent hover:border-red-400/40 rounded-lg p-2 text-white transition-all duration-200 hover:-translate-y-0.5 min-h-[4.5rem] flex flex-col items-center justify-center text-center"
                            >
                                <h3 className="text-sm font-semibold mb-0.5 whitespace-nowrap">{name}</h3>
                                <p className={`italic text-xs ${levelColors[level] || 'text-gray-400'}`}>
                                    {level}
                                </p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}